<template>
  <path pid="0" d="M21 12H7.41l4.3-4.29a1 1 0 10-1.42-1.42l-6 6-.09.11a.35.35 0 000 .08V12.65a.25.25 0 000 .07.13.13 0 010 .06V13a.76.76 0 000 .15.25.25 0 000 .07V13.39a.35.35 0 000 .08l.07.08 6 6a1 1 0 001.42 0l.08-.1a1 1 0 00-.08-1.32L7.41 14H21a1 1 0 001-1v-.12a1 1 0 00-1-.88zM6.8 14.31z"/>
</template>
